export default __webpack_public_path__ + "static/media/bz11.1951fc91.png";